import { render, staticRenderFns } from "./ResponsiveTable.vue?vue&type=template&id=cec713b0&scoped=true&"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js&"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveTable.vue?vue&type=style&index=0&id=cec713b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec713b0",
  null
  
)

export default component.exports